// AllocationsPage.jsx

// Dependencies
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// Components
import Allocations from '@/components/data/allocations/Allocations';
import LoadingOverlay from '@/components/common/LoadingOverlay';

// Services
import { getAllocationsWithClientDetails } from '@/services/schedulingService';

// Styling
import { allocationsCss } from '@digital_monorepo/styling';

const AllocationsPage = () => {
  const { t } = useTranslation();

  const [allocations, setAllocations] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        const allocations = await getAllocationsWithClientDetails();
        setAllocations(allocations);
      } catch (error) {
        console.error('Error fetching allocations data:', error);
        setAllocations([])
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, []);

  return (
    <div className={allocationsCss.pageContainer}>
      {loading && <LoadingOverlay />}
      {allocations && <Allocations allocations={allocations} />}
    </div>
  );
};

export default AllocationsPage;
